export default __webpack_public_path__ + "static/media/classify-reyan.c5bfb8b7.jpg";